/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const revealUps = document.querySelectorAll('.reveal-up');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (revealUps.length > 0) {
  enterView({
    selector: '.reveal-up',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

function carouselNav(el) {
  const wrapper = el.closest('.carousel-nav__wrapper');
  if (!wrapper) return undefined;
  return {
    prevEl: wrapper.querySelector('.carousel-nav--prev'),
    nextEl: wrapper.querySelector('.carousel-nav--next')
  };
}

/* Swiper Initialiser */
document
  .querySelectorAll('.featured-collection__items.swiper')
  .forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.5,
      watchOverflow: true,
      navigation: carouselNav(el),
      breakpoints: {
        768: {
          slidesPerView: 3.5
        },
        1024: {
          slidesPerView: 6
        }
      }
    });
  });

/* Scrolling Cards Swiper */

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)')
    .matches;
}

function initCardsSwiper(el) {
  if (!el || typeof Swiper === 'undefined' || el.swiper) return;

  const reduceMotion = prefersReducedMotion();

  const swiper = new Swiper(el, {
    slidesPerView: 1.2,
    spaceBetween: 0,
    freeMode: true,
    loop: true,
    allowTouchMove: true,
    speed: 7500,
    autoplay: reduceMotion
      ? false
      : {
          delay: 0,
          disableOnInteraction: false
        },
    breakpoints: {
      750: {
        slidesPerView: 3.5
      }
    }
  });

  if (reduceMotion) return;

  let paused = false;
  let stoppedByUser = false;

  swiper.on('touchEnd', (instance, event) => {
    const pointer = event && event.pointerType;
    const type = (event && event.type) || '';
    if (pointer !== 'touch' && !type.startsWith('touch')) return;
    stoppedByUser = true;
    pauseMarquee();
  });

  function pauseMarquee() {
    if (swiper.destroyed || paused) return;
    paused = true;
    const currentTranslate = swiper.getTranslate();
    swiper.autoplay?.stop();
    swiper.setTransition(0);
    swiper.setTranslate(currentTranslate);
    swiper.animating = false;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function resumeMarquee() {
    if (swiper.destroyed || stoppedByUser || !paused) return;
    paused = false;
    swiper.autoplay?.start();
  }

  function hasFocusWithin() {
    return (
      document.activeElement && el.contains(document.activeElement)
    );
  }

  function releaseMarquee() {
    if (hasFocusWithin() || el.matches(':hover')) return;
    resumeMarquee();
  }

  el.addEventListener('mouseenter', pauseMarquee);
  el.addEventListener('mouseleave', releaseMarquee);

  document.addEventListener('focusin', () => {
    if (swiper.destroyed || !el.isConnected) return;
    if (hasFocusWithin()) {
      pauseMarquee();
    } else {
      releaseMarquee();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (swiper.destroyed || !el.isConnected) return;
    if (document.hidden) {
      pauseMarquee();
    } else {
      releaseMarquee();
    }
  });
}

document
  .querySelectorAll('[data-cards-swiper].swiper')
  .forEach(initCardsSwiper);

/* Books carousel */
document
  .querySelectorAll('.books-carousel__swiper.swiper')
  .forEach(el => {
    const section = el.closest('.books-carousel');
    const nextEl = section?.querySelector('.books-carousel__nav--next')
      || section?.querySelector('.books-carousel__nav');
    const prevEl = section?.querySelector('.books-carousel__nav--prev');

    new Swiper(el, {
      slidesPerView: 2.1,
      spaceBetween: 14,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl,
        prevEl
      },
      breakpoints: {
        768: {
          slidesPerView: 3.3,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 5.4
        }
      }
    });
  });

/* Testimonials carousel */
document
  .querySelectorAll('.testimonials__carousel.swiper')
  .forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.3,
      spaceBetween: 46,
      loop: true,
      grabCursor: true,
      watchOverflow: true,
      navigation: carouselNav(el),
      observer: true,
      observeParents: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        768: {
          spaceBetween: 46,
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 80,
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });
  });

new Swiper('.announcement-swiper', {
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: prefersReducedMotion()
    ? false
    : {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
  speed: 800
});

/* Multicolumn: swiper on mobile/tablet only */
(function () {
  const mq = window.matchMedia('(max-width: 1023px)');
  document
    .querySelectorAll('.multicolumn__items.swiper')
    .forEach(el => {
      let instance = null;
      function update() {
        if (mq.matches && !instance) {
          instance = new Swiper(el, {
            slidesPerView: 1.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            watchOverflow: true,
            navigation: carouselNav(el),
            breakpoints: {
              768: {
                slidesPerView: 2.5
              }
            }
          });
        } else if (!mq.matches && instance) {
          instance.destroy(true, true);
          instance = null;
        }
      }
      update();
      mq.addEventListener('change', update);
    });
})();

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  if (modalActive) modalActive.classList.toggle(className);
}

document
  .querySelectorAll('[data-address-toggle]')
  .forEach(button => {
    button.addEventListener('click', () => {
      const expanded =
        button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
    });
  });

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');
  });
});

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* FAQ Accordion */
document.querySelectorAll('[data-faq-item]').forEach(item => {
  const trigger = item.querySelector('[data-faq-trigger]');
  if (!trigger) return;
  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* Hero Slider */
function initHeroSlider(context = document) {
  const sliders = context.querySelectorAll('.hero-slider .swiper');
  if (!sliders.length) return;

  sliders.forEach(sliderEl => {
    if (sliderEl.classList.contains('swiper-initialized')) return;

    const wrapper = sliderEl.closest('.hero-slider');
    const progressBars = wrapper.querySelectorAll(
      '.progress-bar__fill'
    );
    const navButtons = wrapper.querySelectorAll('.hero-slider__btn');

    let hasTriggered = false;

    const swiper = new Swiper(sliderEl, {
      loop: true,
      speed: 600,
      autoplay: prefersReducedMotion()
        ? false
        : {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      on: {
        init() {
          setActiveNav(this.realIndex);
        },

        slideChange(swiper) {
          setActiveNav(swiper.realIndex);

          hasTriggered = false;
        },

        autoplayTimeLeft(swiper, time, progress) {
          const activeIndex = swiper.realIndex;
          const percentage = (1 - progress) * 100;

          progressBars.forEach((bar, i) => {
            if (i < activeIndex) {
              bar.style.width = '100%';
            } else if (i === activeIndex) {
              bar.style.width = `${percentage}%`;
            } else {
              bar.style.width = '0%';
            }
          });

          if (percentage > 92 && !hasTriggered) {
            hasTriggered = true;
            swiper.slideNext();
          }
        }
      }
    });

    function setActiveNav(index) {
      navButtons.forEach(btn => btn.classList.remove('is-active'));
      if (navButtons[index]) {
        navButtons[index].classList.add('is-active');
      }
    }

    navButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const index = parseInt(btn.dataset.slide);
        swiper.slideToLoop(index);

        hasTriggered = false;
      });
    });
  });
}

// Load more button function (collections, search)
function initLoadMore() {
  const buttons = document.querySelectorAll('.js-load-more');
  if (!buttons.length) return;

  buttons.forEach(button => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener('click', function () {
      const nextUrl = button.dataset.nextUrl;
      const containerSelector = button.dataset.container;

      if (!nextUrl || !containerSelector) return;

      const container = document.querySelector(containerSelector);
      if (!container) return;

      button.classList.add('is-loading');

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContainer = doc.querySelector(containerSelector);
          const newButton = doc.querySelector('.js-load-more');

          if (newContainer) {
            const temp = document.createElement('div');
            temp.innerHTML = newContainer.innerHTML;

            const newItems = temp.querySelectorAll('.reveal-up');

            newItems.forEach(el => {
              el.classList.remove('entered');
            });

            while (temp.firstChild) {
              container.appendChild(temp.firstChild);
            }

            requestAnimationFrame(() => {
              newItems.forEach((el, i) => {
                el.classList.add('entered');
              });
            });
          }
          if (newButton) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            button.remove();
          }
        })
        .finally(() => {
          button.classList.remove('is-loading');
        });
    });
  });
}

// END OF LOAD MORE BUTTON

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => {
    link.classList.remove('active');
    link.removeAttribute('aria-current');
  });

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
        link.setAttribute('aria-current', 'page');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
    addressLink?.setAttribute('aria-current', 'page');
  }
}

// Product Recommendations (PDP)
function initProductRecommendations(context = document) {
  const sections = context.querySelectorAll(
    '[data-product-recommendations]'
  );
  if (!sections.length) return;

  sections.forEach(section => {
    if (section.dataset.loaded === 'true') return;

    const url = section.dataset.url;

    // Manual/metafield mode — products are already in the DOM, just init the swiper
    if (!url) {
      const wrapper = section.querySelector('.swiper-wrapper');
      if (wrapper && wrapper.children.length > 0) {
        initRecommendationSwiper(section);
        section.dataset.loaded = 'true';
      }
      return;
    }

    const wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newSlides = temp.querySelectorAll(
          '.product-recommendations__card'
        );
        if (!newSlides.length) return;

        wrapper.innerHTML = '';

        newSlides.forEach(slide => {
          wrapper.appendChild(slide);
        });

        initRecommendationSwiper(section);

        section.dataset.loaded = 'true';
      })
      .catch(err => {
        console.error('Recommendation fetch failed:', err);
      });
  });
}

// Product recommendations swiper
function initRecommendationSwiper(section) {
  const swiperEl = section.querySelector(
    '[data-recommendation-swiper]'
  );
  if (!swiperEl) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 16,
    watchOverflow: true,
    navigation: carouselNav(swiperEl),
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 150,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  });
}

// Collection Filtering //
function initCollectionFacets() {
  const collectionPage = document.querySelector(
    '.js-collection-page'
  );
  if (!collectionPage) return;

  const modal = collectionPage.querySelector('#FiltersModal');
  const openBtn = collectionPage.querySelector('.open-filters');
  const closeBtn = collectionPage.querySelector('.filters-close');
  const overlay = collectionPage.querySelector('.filters-overlay');
  const form = collectionPage.querySelector('#FiltersForm');
  const countEl = collectionPage.querySelector('#ActiveFilterCount');
  const headerCountEl = collectionPage.querySelector(
    '#ActiveFilterCountHeader'
  );
  const applyButton = collectionPage.querySelector(
    '.filter__apply-button'
  );

  if (!modal) return;

  // Open/close modal
  const modalFocus = createOverlayFocus(modal, () => closeModal());

  const openModal = () => {
    modal.classList.add('active');
    document.body.classList.add('no-scroll');
    modalFocus.open();
  };

  const closeModal = () => {
    modal.classList.remove('active');
    document.body.classList.remove('no-scroll');
    modalFocus.close();
  };

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);
  form?.addEventListener('submit', closeModal);

  // Accordion
  collectionPage
    .querySelectorAll('.js-accordion-toggle')
    .forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        const group = toggle.closest('.filter-group');
        const options = group?.querySelector('.filter-options');
        const isOpen = options?.classList.toggle('active');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
      });
    });

  // checkbox states
  const syncActiveCheckboxes = () => {
    collectionPage
      .querySelectorAll('.filter-options input[type="checkbox"]')
      .forEach(input => {
        const label = input.closest('label');
        if (!label) return;
        label.classList.toggle('is-active', input.checked);
      });
  };

  collectionPage.addEventListener('change', e => {
    const input = e.target;

    if (input.type === 'checkbox' || input.type === 'radio') {
      const label = input.closest('label');
      label?.classList.toggle('is-active', input.checked);

      // For radios, remove active from siblings
      if (input.type === 'radio') {
        const radios = collectionPage.querySelectorAll(
          `input[name="${input.name}"]`
        );
        radios.forEach(radio => {
          const l = radio.closest('label');
          l?.classList.toggle('is-active', radio.checked);
        });
      }
    }

    updateFilterCount();
    updateProductCount();
  });

  const updateFilterCount = () => {
    if (!form) return;

    let count = 0;

    const checkedBoxes = form.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    count += checkedBoxes.length;

    const minInput = form.querySelector(
      'input[name*="filter.v.price.gte"]'
    );
    const maxInput = form.querySelector(
      'input[name*="filter.v.price.lte"]'
    );

    if (minInput?.value || maxInput?.value) {
      count += 1;
    }

    const formatted = count > 0 ? `(${count})` : '';

    if (countEl) countEl.textContent = formatted;
    if (headerCountEl) headerCountEl.textContent = formatted;
  };

  const updateProductCount = async () => {
    if (!form || !applyButton) return;

    const url = new URL(form.action, window.location.origin);
    const params = new URLSearchParams();

    // Checkboxes
    form
      .querySelectorAll('input[type="checkbox"]:checked')
      .forEach(input => {
        params.append(input.name, input.value);
      });

    // Radios
    form
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(input => {
        params.append(input.name, input.value);
      });

    // Price range
    const minInput = form.querySelector(
      'input[name*="filter.v.price.gte"]'
    );
    const maxInput = form.querySelector(
      'input[name*="filter.v.price.lte"]'
    );

    if (minInput?.value) {
      params.append(minInput.name, minInput.value);
    }

    if (maxInput?.value) {
      params.append(maxInput.name, maxInput.value);
    }

    try {
      const response = await fetch(
        `${url.pathname}?${params.toString()}`
      );
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const countEl = doc.querySelector('.collection__filter-number');
      const productCount =
        countEl?.textContent.match(/\d+/)?.[0] || 0;

      applyButton.textContent = `View ${productCount} Products`;
    } catch (error) {
      console.error('Error fetching product count:', error);
    }
  };

  syncActiveCheckboxes();
  updateFilterCount();
}

// Announcement bar
function initAnnouncementBar() {
  const body = document.body;
  const bar = document.getElementById('announcement-bar');

  if (!bar) return;

  bar.classList.remove('hidden-by-default');
  body.classList.add('announcement-bar-visible');
}

function initCurrencySelectors() {
  const selectors = document.querySelectorAll('.currency-selector');
  if (!selectors.length) return;

  selectors.forEach(selector => {
    const form = selector.closest('form');

    resizeCurrencySelector(selector);

    selector.addEventListener('change', () => {
      resizeCurrencySelector(selector);
      form.submit();
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      selectors.forEach(resizeCurrencySelector);
    }, 150);
  });
}

function resizeCurrencySelector(selector) {
  let temp = selector._tempMeasure;

  if (!temp) {
    temp = document.createElement('span');
    temp.style.visibility = 'hidden';
    temp.style.position = 'absolute';
    temp.style.whiteSpace = 'nowrap';

    document.body.appendChild(temp);
    selector._tempMeasure = temp;
  }

  const measured = window.getComputedStyle(selector);
  temp.style.font = measured.font;
  temp.style.letterSpacing = measured.letterSpacing;
  temp.style.wordSpacing = measured.wordSpacing;
  temp.style.textTransform = measured.textTransform;

  const text = selector.options[selector.selectedIndex].text;
  temp.textContent = text;

  const textWidth = temp.offsetWidth;

  const style = window.getComputedStyle(selector);
  const padding =
    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

  const buffer = 24;

  selector.style.width = textWidth + padding + buffer + 'px';
}

// Cart drawer quantity stepper — delegated so it survives liquid-ajax-cart
// section re-renders without needing to re-bind listeners.
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-cart-qty-action]');
  if (!btn) return;
  const wrap = btn.closest('[data-cart-qty]');
  if (!wrap) return;
  const input = wrap.querySelector(
    'input[data-ajax-cart-quantity-input]'
  );
  if (!input) return;
  const current = parseInt(input.value, 10) || 0;
  const next =
    btn.dataset.cartQtyAction === 'increase'
      ? current + 1
      : Math.max(0, current - 1);
  if (next === current) return;
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Screen reader announcements */
function announce(message) {
  const region = document.getElementById('a11y-announcer');
  if (!region || !message) return;

  region.textContent = '';
  window.setTimeout(() => {
    region.textContent = message;
  }, 100);
}

function initCartAnnouncements() {
  if (
    typeof liquidAjaxCart === 'undefined' ||
    !liquidAjaxCart.subscribeToCartAjaxRequests
  ) {
    return;
  }

  liquidAjaxCart.subscribeToCartAjaxRequests(
    (state, subscribeToResult) => {
      const type = state.requestType;
      if (!['add', 'change', 'update'].includes(type)) return;

      subscribeToResult(result => {
        if (!result.responseData?.ok) {
          announce('Sorry, the cart could not be updated.');
          return;
        }

        const count = result.responseData?.body?.item_count;

        if (type === 'add') {
          announce(
            count === undefined
              ? 'Item added to your cart'
              : `Item added to your cart. ${count} ${
                  count === 1 ? 'item' : 'items'
                } in cart.`
          );
        } else {
          announce(
            count === undefined
              ? 'Cart updated'
              : `Cart updated. ${count} ${
                  count === 1 ? 'item' : 'items'
                } in cart.`
          );
        }
      });
    }
  );
}

/* Overlay focus management */
const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ');

function getFocusableWithin(container) {
  return Array.from(
    container.querySelectorAll(FOCUSABLE_SELECTOR)
  ).filter(
    el =>
      el.offsetWidth > 0 ||
      el.offsetHeight > 0 ||
      el.getClientRects().length > 0
  );
}

function createOverlayFocus(panel, close) {
  let lastFocused = null;

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    const items = getFocusableWithin(panel);
    if (!items.length) {
      e.preventDefault();
      panel.focus();
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function focusPanel(attempt) {
    if (!panel.isConnected) return;

    const visible =
      window.getComputedStyle(panel).visibility === 'visible';

    if (visible) {
      panel.focus();
      return;
    }

    if (attempt > 60) return;
    requestAnimationFrame(() => focusPanel(attempt + 1));
  }

  return {
    open() {
      lastFocused = document.activeElement;
      focusPanel(0);
      document.addEventListener('keydown', onKeydown);
    },
    close() {
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      lastFocused = null;
    }
  };
}

function initCartDrawerFocus() {
  const section = document.getElementById('shopify-section-my-cart');
  const panel = section?.querySelector('.cart-modal__inner');
  if (!panel) return;

  const isOpen = () =>
    document.body.classList.contains('js-my-cart-open');
  const focus = createOverlayFocus(panel, () =>
    document.body.classList.remove('js-my-cart-open')
  );

  let wasOpen = isOpen();

  new MutationObserver(() => {
    const open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      focus.open();
    } else {
      focus.close();
    }
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  if (
    typeof liquidAjaxCart !== 'undefined' &&
    liquidAjaxCart.subscribeToCartSectionsUpdate
  ) {
    liquidAjaxCart.subscribeToCartSectionsUpdate(() => {
      if (!isOpen()) return;

      const current = document
        .getElementById('shopify-section-my-cart')
        ?.querySelector('.cart-modal__inner');

      if (current && !current.contains(document.activeElement)) {
        current.focus();
      }
    });
  }
}

// Init functions
window.addEventListener('hashchange', handleAccountPageNav);

document.addEventListener('DOMContentLoaded', function () {
  initLoadMore();
  handleAccountPageNav();
  initProductRecommendations();
  initCollectionFacets();
  initAnnouncementBar();
  initCurrencySelectors();
  initHeroSlider();
  initCartDrawerFocus();
  initCartAnnouncements();
});

document.addEventListener('shopify:section:load', event => {
  event.target
    .querySelectorAll('[data-cards-swiper].swiper')
    .forEach(initCardsSwiper);
  initProductRecommendations(event.target);
  initHeroSlider(event.target);
});
